var React = require('react');

function TrafficLightStop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M240 112a48 48 0 1 1-48-48 48 48 0 0 1 48 48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.79 28.19 78.61 66.86 91v-.15a128 128 0 0 0 250.34 0v.15c38.61-12.4 66.8-48.22 66.8-91h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416a48 48 0 1 1 48-48 48 48 0 0 1-48 48zm0-128a48 48 0 1 1 48-48 48 48 0 0 1-48 48zm0-128a48 48 0 1 1 48-48 48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

TrafficLightStop.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = TrafficLightStop;

TrafficLightStop.default = TrafficLightStop;
